export default "__VITE_ASSET__BKDW4$7h__"